/**
 * User-facing copy for the Business Functions / lead module.
 * Domain term is "Campaign" (not "Workspace").
 * Internal routes, hooks, and API params may still use "workspace".
 */
export const CAMPAIGN_COPY = {
  label: 'Campaign',
  labelPlural: 'Campaigns',
  untitled: 'Untitled Campaign',
  defaultName: 'Campaign',

  tab: {
    label: 'Bussiness Services',
  },

  list: {
    titleInAccount: (accountName) => `Bussiness Services in ${accountName || 'Account'}`,
    subtitle: 'Business services you can access under this business function.',
    newButton: 'New Business Service',
    newButtonDenied: 'You do not have permission to create a business service',
    active: 'Active',
    inactive: 'Inactive',
    activated: 'Business service activated',
    deactivated: 'Business service deactivated',
    toggleFailed: 'Unable to update business service status',
    disabledBlocked: 'This business service is inactive.',
  },

  create: {
    title: 'Create Business Service',
    subtitle:
      'Fill in the essentials — location and other values are set automatically so you can create quickly.',
    submit: 'Create business service',
    cancel: 'Cancel',
    fields: {
      name: 'Business service name',
      tentativeBudget: 'Tentative budget',
      costOfLeads: 'Cost of leads',
    },
    validation: {
      nameRequired: 'Business service name is required',
      tentativeBudgetRequired: 'Tentative budget is required',
      tentativeBudgetInvalid: 'Enter a valid tentative budget',
      costOfLeadsRequired: 'Cost of leads is required',
      costOfLeadsInvalid: 'Enter a valid cost of leads',
    },
    success: 'Business service created successfully',
    confirmForm: {
      title: 'Create a form?',
      message: 'Do you want to create a lead form for this business service now?',
      confirm: 'Yes, create form',
      cancel: 'Not now',
    },
    discard: {
      title: 'Discard changes?',
      message: 'You have unsaved changes. Close without creating this business service?',
      keepEditing: 'Keep editing',
      discard: 'Discard',
    },
    errors: {
      createFailed: 'Unable to create business service',
      accountMissing: 'Business function is missing. Please refresh and try again.',
      organisationMissing: 'Organisation is missing. Please sign in again.',
    },
  },

  empty: {
    title: 'No campaigns available',
    loadError: 'Unable to load business services for this account.',
    noAccess:
      'No business services are assigned to your profile for this business function yet. Ask an administrator to grant access in Profile Permissions.',
  },

  errors: {
    loadList: 'Unable to load campaigns',
    loadDetail: 'Unable to load campaign',
    loadForms: 'Unable to load campaign forms',
  },

  detail: {
    zeroStateNoTables: 'No tables in this campaign yet',
    zeroStateViewOnly:
      'You have view-only access to this campaign. Contact your administrator if you need permission to create tables or forms.',
    starAriaLabel: 'Star campaign',
    optionsAriaLabel: 'Campaign options',
    tableRecordsAriaLabel: 'Campaign table records',
  },

  settings: {
    title: 'Campaign Settings',
    subtitle: 'General configuration and campaign properties',
    nameLabel: 'Campaign Name',
  },

  stats: {
    totalCampaigns: 'Total Campaigns',
  },
};
